import React, { forwardRef } from 'react';

import { CopyIcon } from 'src/components/icons/CopyIcon';
import { BaseMenuOption } from 'src/editor/toolbars/menus/BaseMenuOption';
import type { CommonMenuItemProps } from 'src/editor/toolbars/menus/types';
import { ClientTransforms } from 'src/editor/transforms';
import { useDispatchSuccessSnack, useDocumentParams } from 'src/helpers';
import { useEditor } from 'src/layout-engine';
import { editorHotkeys } from 'src/layout-engine/components/KeyboardInputHandler';
import { v4 as uuid4 } from 'uuid';

/**
 * @deprecated Once the context menu is using DeclarativeMenu, remove this and refactor out the
 * relevant menu item configs from useEditMenu instead.
 */
export const EditCopyMenuItem = forwardRef(function EditCopyMenuItem(
  props: CommonMenuItemProps,
  ref: React.Ref<HTMLLIElement>
): JSX.Element {
  const { closeRootMenu, ...rest } = props;
  const editor = useEditor();
  const { documentId } = useDocumentParams();
  const dispatchSuccessSnack = useDispatchSuccessSnack({
    key: uuid4(),
    message: 'Content copied to clipboard.',
  });

  async function handleCopy(): Promise<void> {
    closeRootMenu();

    const isCopied = await ClientTransforms.copyToClipboard(editor, { documentId });
    if (isCopied) {
      dispatchSuccessSnack();
    }
    ClientTransforms.focus(editor);
  }

  return (
    <BaseMenuOption
      ref={ref}
      icon={<CopyIcon />}
      label="Copy"
      shortCutKey={editorHotkeys.copy.hint}
      onClick={handleCopy}
      {...rest}
    />
  );
});
